
export const MONOLITH_LOGIN_ENDPOINT = '/login/spa';
